import AlgoliaDatePicker from './algolia-date-picker'

type AlgoliaDateFilterProps = {
  heading?: string
  state: {
    startDateFilter: number | null
    endDateFilter: number | null
  }
  stateCallbacks: {
    setStartDateFilter: (date: number) => void | null
    setEndDateFilter: (date: number) => void | null
  }
}

export default function AlgoliaDateFilter({
  heading,
  state,
  stateCallbacks,
}: AlgoliaDateFilterProps) {
  return (
    <>
      {heading ? <h5 className="h5 font-semibold mb-md">{heading}</h5> : null}

      <ul className="flex items-center max-sm:flex-col gap-sm mb-2xl">
        <li className="w-full">
          <AlgoliaDatePicker
            label="From"
            state={state.startDateFilter}
            stateCallback={stateCallbacks?.setStartDateFilter}
          />
        </li>

        <li>–</li>

        <li className="w-full">
          <AlgoliaDatePicker
            label="To"
            state={state.endDateFilter}
            stateCallback={stateCallbacks?.setEndDateFilter}
          />
        </li>
      </ul>
    </>
  )
}
